import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import WelcomeName from "./WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";

const NavBar = () => {
  return (
    <div style={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <WelcomeName />
          <SignInSignOutButton />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default NavBar;
